import React from 'react';
import IMG_1 from '../../../Images/gallery/home/img_1.png';
import IMG_2 from '../../../Images/gallery/home/img_2.png';
import IMG_3 from '../../../Images/gallery/home/img_3.png';
import IMG_4 from '../../../Images/gallery/home/img_4.png';
import IMG_5 from '../../../Images/gallery/home/img_5.png';
import IMG_6 from '../../../Images/gallery/home/img_6.png';
import IMG_7 from '../../../Images/gallery/home/img_7.png';
import IMG_8 from '../../../Images/gallery/home/img_8.png';
import IMG_9 from '../../../Images/gallery/home/img_9.png';
import IMG_10 from '../../../Images/gallery/home/img_10.png';
import IMG_11 from '../../../Images/gallery/home/img_11.png';
import IMG_12 from '../../../Images/gallery/home/img_12.png';
import IMG_13 from '../../../Images/gallery/home/img_13.png';
import IMG_14 from '../../../Images/gallery/home/img_14.png';

export const TEXT_OUR = [
  {
    textSize: '4rem',
    textType: 'h2',
    marginBottom: '0px',
    textMobile: '1.5rem',
    renderContent: () => <span>NUESTRA HUELLA VISUAL</span>,
  },
  {
    textSize: '1.5rem',
    marginBottom: '2.5rem',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>
        Más que producción, definimos estéticas. Creamos lenguajes visuales que
        elevan marcas, artistas y narrativas en la cultura contemporánea.
      </span>
    ),
  },
];

export const imagesSources = [
  { id: 'film-1', src: IMG_1, widthPercent: 40, target: 'portfolio-films' },
  { id: 'cultural', src: IMG_2, widthPercent: 20, target: 'cultural' },
  { id: 'film-7', src: IMG_3, widthPercent: 20, target: 'portfolio-films' },
  {
    id: 'campaign-interceramic',
    src: IMG_4,
    widthPercent: 20,
    target: 'campaign-interceramic',
  },
  {
    id: 'campaign-savile',
    src: IMG_5,
    widthPercent: 20,
    target: 'campaign-savile',
  },
  {
    id: 'campaign-betvip-2',
    src: IMG_6,
    widthPercent: 20,
    target: 'campaign-betvip-2',
  },
  {
    id: 'campaign-gire',
    src: IMG_7,
    widthPercent: 60,
    target: 'campaign-gire',
  },
  {
    id: 'campanas-idealz',
    src: IMG_8,
    widthPercent: 20,
    target: 'campanas-idealz',
  },
  { id: 'film-9', src: IMG_9, widthPercent: 20, target: 'portfolio-films' },
  {
    id: 'campaign-torres',
    src: IMG_10,
    widthPercent: 40,
    target: 'campaign-torres',
  },
  {
    id: 'fashion-knockout',
    src: IMG_11,
    widthPercent: 20,
    target: 'fashion-knockout',
  },
  {
    id: 'campaign-betvip',
    src: IMG_12,
    widthPercent: 60,
    target: 'campaign-betvip',
  },
  {
    id: 'campaign-idealz',
    src: IMG_13,
    widthPercent: 20,
    target: 'campaign-idealz',
  },
  {
    id: 'campaign-puma',
    src: IMG_14,
    widthPercent: 20,
    target: 'campaign-puma',
  },
];
